/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { Invoice } from '../types';

export const getLastDisputeReason = (invoice: Invoice) => _.get(
  _.maxBy(
    invoice?.logs?.filter((log) => log.event === 'SetStatus' && log.data.status === 'disputed'),
    (log) => new Date(log.time),
  ),
  'data.notes',
) as string | '';
